module.exports = __webpack_public_path__ + "img/beer_id-92.49bdab2a.png";